import React from 'react';

export default function AppRestrict() {
  return <div>This website is restricted to TPE-USERS ldap group only.</div>;
}
